import { Head, Link, router } from '@inertiajs/react'
import { useState } from 'react'
import SuperAdminLayout from '../_SuperAdminLayout'
import RoleConversionModal from '../_RoleConversionModal'
import { sortPeople } from '../../../utils/peopleSort'

interface Guide {
  id: number
  email: string
  full_name: string
  organizations: string[]
  can_impersonate?: boolean
  impersonate_path?: string
}

interface Props { guides: Guide[] }

export default function GuidesIndex({ guides }: Props) {
  const [convertTarget, setConvertTarget] = useState<Guide | null>(null)

  return (
    <SuperAdminLayout>
      <Head title="Guides" />
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-bold text-text-primary">Guides</h1>
        <div className="flex items-center gap-3">
        <Link
          href="/super_admin/guide_activity"
          className="px-4 py-2 border border-stone/30 text-text-primary text-sm font-semibold rounded-lg hover:bg-white"
        >
          Activity report
        </Link>
        <Link
          href="/super_admin/guides/new"
          className="px-4 py-2 bg-[#351E1D] text-white text-sm font-semibold rounded-lg hover:bg-[#351E1D]/90"
        >
          Create Guide
        </Link>
        </div>
      </div>

      <div className="bg-white border border-stone/20 rounded-lg overflow-hidden">
        {guides.length === 0 ? (
          <div className="py-10 text-center text-text-muted text-sm">No Guides yet.</div>
        ) : (
          <table className="w-full text-sm">
            <thead className="bg-[#F5F5F5] text-text-secondary">
              <tr>
                <th className="text-left px-4 py-2.5 font-medium">Name</th>
                <th className="text-left px-4 py-2.5 font-medium">Email</th>
                <th className="text-left px-4 py-2.5 font-medium">Companies guided</th>
                <th className="text-right px-4 py-2.5 font-medium">Actions</th>
              </tr>
            </thead>
            <tbody>
              {sortPeople(guides).map(g => (
                <tr key={g.id} className="border-t border-stone/15">
                  <td className="px-4 py-3 text-text-primary font-medium">
                    {g.full_name}
                  </td>
                  <td className="px-4 py-3 text-text-muted">{g.email}</td>
                  <td className="px-4 py-3 text-text-muted">
                    {g.organizations.length === 0 ? 'No companies yet' : g.organizations.join(', ')}
                  </td>
                  <td className="px-4 py-3 text-right">
                    <div className="flex items-center justify-end gap-2">
                      {g.can_impersonate !== false && (
                        <button
                          onClick={() => router.post(g.impersonate_path ?? `/super_admin/guides/${g.id}/impersonate`)}
                          className="text-xs px-2 py-1 bg-[#351E1D] text-white rounded hover:bg-[#351E1D]/90"
                        >
                          Impersonate Guide
                        </button>
                      )}
                      <button
                        onClick={() => setConvertTarget(g)}
                        className="text-xs px-2 py-1 border border-stone/30 rounded hover:bg-[#F5F5F5]"
                      >
                        Convert to regular user
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {convertTarget && (
        <RoleConversionModal
          accountId={convertTarget.id}
          accountName={convertTarget.full_name}
          direction="to_user"
          onClose={() => setConvertTarget(null)}
        />
      )}
    </SuperAdminLayout>
  )
}
